import type {BaseTask} from '@github-ui/agent-sessions/types/task'
import {generateTaskPath, generateTaskPathForRepo} from '@github-ui/agent-sessions/utils/generate-task-path'

/**
 * Absolute URLs a task may appear under in copilot-chat task-list payloads — map keys for
 * `useTaskStateSync`. `nwo` is optional on `BaseTask`; the caller derives it from PR/repo data.
 *
 * `github/copilot-chat#458` converges onto the second; first stays for older chat history.
 * - codeagentskill (PR-backed):  `{origin}/copilot/tasks/pull/{resource_global_id}`
 * - deepresearchskill (no PR):   `{origin}/{nwo}/tasks/{task.id}`
 *
 * Returns `[]` for unmappable tasks. Keys have no query string or fragment.
 */
export function taskUrlKeys(
  task: Pick<BaseTask, 'resource_global_id' | 'id'>,
  nwo: string | undefined,
  origin: string,
): string[] {
  const keys: string[] = []
  if (task.resource_global_id) {
    keys.push(`${origin}${generateTaskPath(task.resource_global_id)}`)
  }
  if (nwo && task.id) {
    const path = generateTaskPathForRepo({repositoryNwo: nwo, taskId: task.id})
    if (path) keys.push(`${origin}${path}`)
  }
  return keys
}

/** Strips query string and fragment so a URL can be used as a {@link taskUrlKeys} map key. */
export function normalizeTaskUrl(url: string): string {
  return url.split(/[?#]/, 1)[0] ?? url
}
